import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import StillBuildingView from './views/StillBuildingView';
import StillBuildingHomeView from './views/StillBuildingHomeView';
import { useStillBuilding } from './hooks/StillBuilding.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const StillBuildingController = () => {
  const { loading, error, handleSubmit } = useStillBuilding();
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const onStillBuilding = async values => {
    console.log(' DATOS GUARDADOS EN Register Now:', values);
    console.log('Email:', values.email);
    console.log('Password:', values.password);
  };

  const handleRegister = () => {
    console.log('Redirigiendo a registro...');
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <>
      <FlexContainer className={'flex-column width100 d-hide'}>
        <StillBuildingView
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleSubmit(values, onStillBuilding)}
          loading={loading}
          error={error}
          languageData={languageData}
          onBack={handleBack}
          onRegister={handleRegister}
        />
      </FlexContainer>
      <FlexContainer className={'flex-column width100 m-hide'}>
        <StillBuildingHomeView
          loading={loading}
          error={error}
          languageData={languageData}
        />
      </FlexContainer>
    </>
  );
};

export default StillBuildingController;
